import { render, staticRenderFns } from "./create.vue?vue&type=template&id=0416aade&scoped=true&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0416aade",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0416aade')) {
      api.createRecord('0416aade', component.options)
    } else {
      api.reload('0416aade', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=0416aade&scoped=true&", function () {
      api.rerender('0416aade', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/project/template/create.vue"
export default component.exports